<template>
    <div v-show="visibility" :id="name" class="modal-container-old" @click.self="hide">
        <div class="modal">
            <div class="modal-body">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            name: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                visibility: false,
            }
        },
        methods: {
            hide() {
                this.$modals.hide(this.name);
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .modal-container-old {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 96px 0;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, .25);
        z-index: 4;
        animation: fade-in $transition;
        overflow-x: auto;

        .modal {
            min-width: 360px;
            max-width: 640px;
            border-radius: $m-border-radius;
            background-color: $white-color;
            overflow: hidden;

            .modal-body {
                display: grid;
                grid-gap: 24px;
                padding: 24px;
                box-sizing: border-box;
                overflow-y: auto;

                .modal-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    & > span {
                        display: flex;
                        flex-direction: column;
                        color: $text-color-2;
                        font-size: $l-font-size;
                        font-weight: lighter;

                        b {
                            font-weight: normal;
                            color: #000;
                        }

                        & > .modal-desc {
                            margin-top: 6px;
                            font-size: $m-font-size;
                        }
                    }

                    & > img {
                        height: 20px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
